import { I2PEnvironment } from '@price-for-profit/micro-services';
import { CustomerLookup, CustomerNotificationTemplate, NewCustomerForm } from 'shared/types';
import { buildCustomerUrl } from 'shared/utility';

export const defaultNewCustomer: NewCustomerForm = {
  abgmastercustomer: '',
  brands: [],
  customertier: '',
  channel: '',
  l12mproductgrossrevenue: '0',
  numberofcontracts: '0',
  numberofskus: '0',
  pricinglist: '',
  pricingtype: '',
  totalgtn: '0',
  isdeleted: 'FALSE',
  ismarkedfordeletion: 'FALSE',
};

interface TemplateData {
  customer: CustomerLookup;
  userName: string;
}
export const CUSTOMER_EMAIL_TEMPLATES: Record<
  CustomerNotificationTemplate,
  (data: TemplateData) => { body: string; subject: string }
> = {
  delete: ({ customer, userName }) => ({
    subject: `Customer Deletion Requested by ${userName} for ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}`,
    body: `
    The following deletion is being requested:

    customer: ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}

    To View this customer, click here: ${buildCustomerUrl(customer)}
    `,
  }),
  restore: ({ customer, userName }) => ({
    subject: `Customer ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel} Restored by ${userName}`,
    body: `
    The following customer was restored:

    ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}

    To View this customer, click here: ${buildCustomerUrl(customer)}
    `,
  }),
  approve: ({ customer, userName }) => ({
    subject: `Customer Deletion request Approved for ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}`,
    body: `
    The following customer deletion was approved by ${userName}:

    customer: ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}
    `,
  }),
  reject: ({ customer, userName }) => ({
    subject: `Customer Deletion request Rejected for ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}`,
    body: `
    The following customer deletion was rejected by ${userName}:

    customer: ${customer.abgmastercustomer} | ${customer.brand} | ${customer.channel}
    `,
  }),
};

export const CUSTOMER_DELETE_APPROVAL_EMAILS: Record<I2PEnvironment, string[]> = {
  dev: ['upstart.ksoares@insight2profit.com', 'eaquino.upstart@insight2profit.com'],
  sandbox: ['nsaboo@insight2profit.com', 'rlittlejohn@insight2profit.com'],
  prod: ['bkorb@americanbathgroup.com', 'pkinman@americanbathgroup.com'],
  model: [],
};
